import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  productTypeFromModel,
  validateProductTypeCondition,
  type ProductTypeState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_TYPE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ProductTypeState>>,
): ConditionType<ProductTypeState, Condition.ProductType> => ({
  name: CONDITION_NAMES[Condition.PRODUCT_TYPE],
  description(state) {
    return t("Product type: {{types}}", { types: state.join(", ") });
  },
  Details(props: ConditionTypeDetailsProps<ProductTypeState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.ProductType) {
    return productTypeFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PRODUCT_TYPE, productTypes: state };
  },
  valid(state) {
    return validateProductTypeCondition(state).valid;
  },
});
